module.exports = __webpack_public_path__ + "static/media/viva_garden_02_A.30832191.png";